export default function AircraftSlider({keyPrefix = '', images = []}) {

    const sliderRef = React.useRef()
    const sliderPaginationRef = React.useRef()
    const sliderPrevRef = React.useRef()
    const sliderNextRef = React.useRef()

    React.useEffect(() => {
        if (sliderRef.current && sliderPaginationRef.current && sliderPrevRef.current && sliderNextRef.current) {
            new Swiper(sliderRef.current, {
                pagination: {
                    el: sliderPaginationRef.current,
                },
                navigation: {
                    nextEl: sliderNextRef.current,
                    prevEl: sliderPrevRef.current,
                }
            });
        }
    }, [images])

    return <React.Fragment>
        <div ref={sliderRef} className="swiper">
            <div className="swiper-wrapper">
                {images.map((image, index) => {
                    return <div key={`images${keyPrefix}${index}`} className="swiper-slide">
                        <img src={image} style={{width: '550px', height: '360px', objectFit: 'cover'}} alt='' />
                    </div>
                })}
            </div>
        </div>

        {images.length > 1 && <React.Fragment>
            <div ref={sliderNextRef} className="swiper-button-next"></div>
            <div ref={sliderPrevRef} className="swiper-button-prev"></div>
            <div ref={sliderPaginationRef} className="swiper-pagination"></div>
        </React.Fragment>}
    </React.Fragment>
}
